
import { key } from '@/store';
import { defineComponent, computed, ref  } from 'vue'
import { useStore } from 'vuex';
import Temporizador from './Temporizador.vue'

export default defineComponent({
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Formulário",
    emits: ['aoSalvarTarefa'],
    components: {
        Temporizador
    },

    setup(props, {emit}) {
        const store = useStore(key)

        const descricao = ref("")
        const idProjeto = ref("")
        const projetos = computed(() => store.state.projeto.projetos)

        const finalizarTarefa = (tempoDecorrido: number): void => {
            emit('aoSalvarTarefa', {
                duracaoEmSegundos: tempoDecorrido,
                descricao: descricao.value,
                projeto: projetos.value.find(proj => proj.id == idProjeto.value)
            })
            descricao.value = ''
        }
        return {
            descricao,
            idProjeto,
            projetos,
            finalizarTarefa
        }
    }
});
